import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ProductFilter } from "../../ProductFilter/ProductFilter";
import { PRODUCT_LIST_UPLOAD_PROPS } from "../../ProductFilter/constants";
import { ProductFilterValue } from "../../ProductFilter/types";

interface ExclusionSectionProps {
  selectedProductIds: number[];
  onProductSelect: (value: ProductFilterValue) => void;
  isInsideTechInstall?: boolean;
}

export const ExclusionSection: React.FC<ExclusionSectionProps> = React.memo(
  ({ selectedProductIds, onProductSelect }) => {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="body1">
            <Box component="span" fontWeight="bold">
              Exclude
            </Box>{" "}
            companies using{" "}
            <Box component="span" fontWeight="bold">
              any
            </Box>{" "}
            of the following products
          </Typography>
        </Stack>
        <ProductFilter
          onProductsSelect={onProductSelect}
          selectedProductIds={selectedProductIds}
          uploadProps={PRODUCT_LIST_UPLOAD_PROPS}
        />
      </Paper>
    );
  }
);
